import { render, staticRenderFns } from "./studyplan-email.vue?vue&type=template&id=73201504&scoped=true"
import script from "./studyplan-email.vue?vue&type=script&lang=js"
export * from "./studyplan-email.vue?vue&type=script&lang=js"
import style0 from "./studyplan-email.vue?vue&type=style&index=0&id=73201504&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73201504",
  null
  
)

export default component.exports